<template>
  <svg viewBox="0 0 34 29" width="34" height="29">
    <path
      d="M11.836 16.915L17.082.853a.416.416 0 01.417-.296.426.426 0 01.413.3l5.165 16.015 9.65-5.428a.434.434 0 01.506.054.444.444 0 01.1.496L26.266 28c-.11.242-.252.513-.516.648-.376.197-.767 0-.905-.03C20 27.5 15.5 27.5 10.471 28.4c-.364.065-.614.144-.826.095-.416-.096-.64-.442-.818-.796L.67 11.717a.43.43 0 01.081-.508.447.447 0 01.516-.068l10.57 5.774z"
      fill="#fecd33"
    />
  </svg>
</template>
